// Constants for PowerScheduleDialog, mirror of the BE PowerSchedule DTO.
export const POWER_SCHEDULE_MODES = [
    { label: 'Charging', value: 'charging' },
    { label: 'Discharging', value: 'discharging' },
];

export const POWER_SCHEDULE_TYPE = 'fixed';

export const POWER_SCHEDULE_DURATIONS = [1, 2, 3, 4].map((h) => ({ value: h, label: `${h} h` }));

export const POWER_SCHEDULE_CONFLICT = -409; // BE refused: overlaps an open schedule of the same battery

export const POWER_SCHEDULE_DEFAULT_MS = 3 * 60 * 60 * 1000; // default window length on open
